import { LayoutSelector, ScreenFormValues } from '../../Detail/components';
import { Form, FormInstance } from 'antd';
import styled from 'styled-components';
import StorePickerMobile from '../../Detail/components/StorePickerMobile';
import PlaylistPickerMobile from '../../Detail/components/PlaylistPickerMobile';
import playlistApis from 'modules/playlist/services/apis';

interface EditorHeaderMobileProps {
  form: FormInstance<ScreenFormValues>;
}

const EditorHeaderMobile = ({ form }: EditorHeaderMobileProps) => {
  const handlePlaylistChange = async (playListId: string) => {
    form.setFieldsValue({ playListId });

    if (!playListId) return;

    try {
      const res = await playlistApis.getDetailPlaylist(playListId);
      if (res?.data?.data) {
        const playlistDetail = res.data.data;

        form.setFieldsValue({
          contentItems: playlistDetail.contentItems,
        });
      }
    } catch (error) {}
  };
  return (
    <Container>
      <Form.Item name='layoutCode' noStyle>
        <LayoutSelector />
      </Form.Item>
      <Form.Item name='storeId' noStyle>
        <StorePickerMobile />
      </Form.Item>
      <Form.Item name='playListId' noStyle>
        <PlaylistPickerMobile onChange={handlePlaylistChange} currentStoreId={form.getFieldValue('storeId')} />
      </Form.Item>
    </Container>
  );
};

export default EditorHeaderMobile;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 6px;
  padding: 16px;
`;
